import React from "react";
import { CustomShortcut } from "../utils/customShortcutsStorage";

export interface LocationData {
  name: string;
  sunrise: Date | null;
  lat?: number;
  lng?: number;
  apiDisplayName?: string; // The full display name from the API
}

interface DefaultLocationsProps {
  locations: LocationData[];
  customShortcuts: CustomShortcut[];
  onLocationSelect: (locationName: string) => void;
  onCustomShortcutSelect: (shortcut: CustomShortcut) => void;
  onRemoveCustomShortcut: (name: string) => void;
  showSaveButton?: boolean;
  onSaveShortcut?: () => void;
}

const DefaultLocations: React.FC<DefaultLocationsProps> = ({
  locations,
  customShortcuts,
  onLocationSelect,
  onCustomShortcutSelect,
  onRemoveCustomShortcut,
  showSaveButton = false,
  onSaveShortcut,
}) => {
  const handleRemoveClick = (e: React.MouseEvent, name: string) => {
    e.stopPropagation(); // Prevent triggering the location select
    onRemoveCustomShortcut(name);
  };

  return (
    <div className="default-locations">
      <div className="default-locations-title">Scurtături:</div>
      <div className="default-locations-buttons">
        {locations.map((loc, index) => (
          <button
            key={`default-${index}`}
            className="default-location-button"
            onClick={() => onLocationSelect(loc.name)}
          >
            {loc.name}
          </button>
        ))}
        {customShortcuts.map((shortcut, index) => (
          <button
            key={`custom-${index}`}
            className="default-location-button custom-shortcut-button"
            onClick={() => onCustomShortcutSelect(shortcut)}
          >
            {shortcut.name}
            <span
              className="remove-shortcut"
              onClick={(e) => handleRemoveClick(e, shortcut.name)}
              title="Șterge scurtătura"
            >
              ×
            </span>
          </button>
        ))}
        {showSaveButton && onSaveShortcut && (
          <button
            className="default-location-button save-shortcut-button"
            onClick={onSaveShortcut}
            title="Salvează această locație ca scurtătură"
          >
            + Adaugă
          </button>
        )}
      </div>
    </div>
  );
};

export default DefaultLocations;
